import { ProjectPaymentType, ProjectPaymentType2 } from './projectPaymentType'

export const paymentTypeByOldPaymentType: Record<
  ProjectPaymentType,
  ProjectPaymentType2
> = {
  [ProjectPaymentType.QUARTERLY]: ProjectPaymentType2.QUARTERLY,
  [ProjectPaymentType.MONTHLY]: ProjectPaymentType2.MONTHLY,
  [ProjectPaymentType.SEMI_ANNUALLY]: ProjectPaymentType2.SEMI_ANNUALLY,
  [ProjectPaymentType.ANNUALLY]: ProjectPaymentType2.ANNUALLY,
  [ProjectPaymentType.IN_THE_END]: ProjectPaymentType2.IN_THE_END,
  [ProjectPaymentType.NONLINEARLY]: ProjectPaymentType2.NONLINEARLY,
}

export const QUARTERLY_PAYMENT_TYPE_LABEL = 'Kvartálny výnos'
export const MONTHLY_PAYMENT_TYPE_LABEL = 'Mesačný výnos'
export const SEMI_ANNUALLY_PAYMENT_TYPE_LABEL = 'Polročný výnos'
export const ANNUALLY_PAYMENT_TYPE_LABEL = 'Ročný výnos'
export const IN_THE_END_PAYMENT_TYPE_LABEL = 'Výnos na konci'
export const NONLINEARLY_PAYMENT_TYPE_LABEL = 'Nelineárny výnos'
export const YIELD_COMPOUNDING_PAYMENT_TYPE_LABEL = 'Rastúci výnos'

const projectPaymentTypeLabels: Record<
  ProjectPaymentType | ProjectPaymentType2,
  string
> = {
  [ProjectPaymentType.QUARTERLY]: QUARTERLY_PAYMENT_TYPE_LABEL,
  [ProjectPaymentType.MONTHLY]: MONTHLY_PAYMENT_TYPE_LABEL,
  [ProjectPaymentType.SEMI_ANNUALLY]: SEMI_ANNUALLY_PAYMENT_TYPE_LABEL,
  [ProjectPaymentType.ANNUALLY]: ANNUALLY_PAYMENT_TYPE_LABEL,
  [ProjectPaymentType.IN_THE_END]: IN_THE_END_PAYMENT_TYPE_LABEL,
  [ProjectPaymentType.NONLINEARLY]: NONLINEARLY_PAYMENT_TYPE_LABEL,
  [ProjectPaymentType2.QUARTERLY]: QUARTERLY_PAYMENT_TYPE_LABEL,
  [ProjectPaymentType2.MONTHLY]: MONTHLY_PAYMENT_TYPE_LABEL,
  [ProjectPaymentType2.ANNUALLY]: ANNUALLY_PAYMENT_TYPE_LABEL,
  [ProjectPaymentType2.IN_THE_END]: IN_THE_END_PAYMENT_TYPE_LABEL,
  [ProjectPaymentType2.SEMI_ANNUALLY]: SEMI_ANNUALLY_PAYMENT_TYPE_LABEL,
  [ProjectPaymentType2.NONLINEARLY]: NONLINEARLY_PAYMENT_TYPE_LABEL,
}

export function getProjectPaymentTypeLabel(
  projectPaymentType: ProjectPaymentType | ProjectPaymentType2,
  isYieldCompounding: boolean = false
) {
  if (isYieldCompounding) return YIELD_COMPOUNDING_PAYMENT_TYPE_LABEL

  return projectPaymentTypeLabels[projectPaymentType] || projectPaymentType
}
